import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading" //"../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { APICall } from "../../../Helpers/API/APICalls";
//import InputForm from "../../../Components/InputForm/InputForm";
import InputForm from "../../../Components/InputForm/InputForm";
import {
  GetEngagementStageGridData,
  InsertEngagementStagesHistoryData,
  getEngagementDropdownForStage,
  getExportToExcelEngagementStages,
  getStagesDropdown,
  GetMileStonesForStage,
} from "../../../Helpers/API/APIEndPoints";
import notify from "../../../Helpers/ToastNotification";
import { useNavigate } from "react-router-dom";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import moment from "moment";
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { TextField } from '@mui/material';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, Tooltip } from "@mui/material";
import axios from "axios";
import fileDownload from "js-file-download";


//Created by Prashant
function TraceabilityEngagementStages() {
  const { EmployeeId, RoleId } = getContext();
  const [EngagementStagesData, setEngagementStagesData] = useState<any>([]);
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [StagesOptions, setStagesOptions] = useState<any>([]);
  const [selectedEngagement, setSelectedEngagement] = useState<any>({});
  const [selectedStages, setSelectedStages] = useState<any>({});
  const [effectiveDate, setEffectiveDate] = useState<any>(null);
  const [plannedCompletedDate, setPlannedCompletedDate] = useState<any>(null);
  const [remark, setRemark] = useState("");
  const [ProjectMandays, setProjectMandays] = useState();
  // const [BudgetMandays, setBudgetMandays] = useState();
  const [ProjectValue, setProjectValue] = useState();
  const [FormErrors, setFormErrors] = useState<any>({});
  const [page, setPage] = useState(0);
  const [start, setStart] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("");
  const [count, setCount] = useState(0);
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [selectedEngagementValue, setSelectedEngagementValue] = useState<any>(
    {}
  );
  const [isActive, setIsActive] = useState(false);
  const [milestoneOptions,setMilestoneOptions] =useState({});
  const [selectedMilestone,setSelectedMilestone] =useState<any>([]);
  const [engagementType, setEngagementType] = useState(0);
  const [isBillableStage, setIsBillableStage] = useState(false);



  const { showLoader, hideLoader } = useContext(LoaderContext);
  let navigate = useNavigate();

  const options = {
    selectableRows: "none",
    start: start,
    page: page,
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setPage(page);
      setStart(page * pageSize);
    },
  };

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "stage",
      label: "Stage",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "effectiveDate",
      label: " Effective Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        customBodyRender: (value) =>
          value ? moment(value).format("DD/MM/YYYY") : "",
      },
    },
    {
      name: "createdDate",
      label: " Created Date",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value) =>
          //value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : ""
          value ? moment.utc(value).local().format("DD-MM-YYYY HH:mm:ss") : "",
      },
    },
    // {
    //   name: "date",
    //   label: "Date",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     sortDescFirst: true,
    //     customBodyRenderLite: (dataIndex) => {
    //       const dateStr = dataIndex.split(' ')[0];
    //       const [year, month, day] = dateStr.split('-');

    //       // date in 'DDMMYYYY' format
    //       const formattedDate = `${day}${month}${year}`;

    //       return formattedDate;
    //     },
    //   },
    //},

    {
      name: "userName",
      label: "User",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "remark",
      label: "Remark",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
  ];

  const ResetFunction = () => {
    // setSelectedEngagement([]);
    // setSelectedEngagementValue({});
    // setEngagementOptions([]);
    setSelectedEngagement({});
    setSelectedStages({});
    setRemark("");
    setSearchText("");
    setEffectiveDate(null);
    setProjectValue(null);
    setProjectMandays(null);
    //setBudgetMandays(null);
    setPlannedCompletedDate(null);
    //  GetEngagementDropdown();
    setStagesOptions([]);
    setIsActive(false);
    setSelectedMilestone([])
  };

  const GetEngagementDropdown = async () => {
    if (RoleId.includes(3)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 3,
      };

      let data = await APICall(getEngagementDropdownForStage, "POST", obj);

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
            engmentType: d.engagementType,
            engmentStatus: d.engagementStatus
            
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    }
    else if (RoleId.includes(8)) { //added by mahesh on 2024-10-09
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 8,
      };

      let data = await APICall(getEngagementDropdownForStage, "POST", obj);

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
            engmentType:d.engagementType,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }

    }//added by mahesh end 
    else if (RoleId.includes(2)) {
      const obj = {
        EmpId: Number(EmployeeId),
        RoleId: 2,
      };
      let data = await APICall(getEngagementDropdownForStage, "POST", obj);

      if (data.data.length > 0) {
        let tempArray = [];
        await data.data.map((d: any) => {
          let tempObj = {
            label: d.engagement,
            value: d.id,
            engmentType:d.engagementType,
          };
          tempArray.push(tempObj);
        });
        setEngagementOptions(tempArray);
      }
    }
  };

  const GetStagesDropdown = async (id) => {

    let obj = {
      EngagementId: id,
    };

    let data = await APICall(getStagesDropdown, "POST", obj);

    if (data.data.length > 0) {
      let tempArray = [];
      await data.data.map((d: any) => {
        let tempObj = {
          label: d.stages,
          value: d.id,
        };
        tempArray.push(tempObj);
      });

      setStagesOptions(tempArray);
    }
  };
//added by mahesh 
  const GetMilestonesDropdown = async (id) => {

    let requestObject = {
      EngagementId : id
    }
    
    const resp = await APICall(
      GetMileStonesForStage,
      "POST",
      requestObject
    );
   // console.log("milestione resp=",resp);
    if (resp?.data?.length > 0) {
      let tempArray = [];
      await resp.data.map((d: any) => {
        let tempObj = {
          label: d.milestone,
          value: d.id,
        };
        tempArray.push(tempObj);
      });
  
      setMilestoneOptions(tempArray);
    }
    else{
      setMilestoneOptions({});
    }
  
  };
  //end

  useEffect(() => {
    (async () => {
      await GetEngagementDropdown();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await GetEngagementStagesGridData();
    })();
  }, [
    selectedEngagement,
    searchText,
    start,
    sortColumn,
    sortDirection,
    page,
    pageSize,
  ]);

  const handleTextChange = (e: any, apiFieldName: any) => {
    if (apiFieldName == "remark") {
      if (
        selectedStages.value == 10 ||
        selectedStages.value == 11 ||
        selectedStages.value == 12 ||
        selectedStages.value == 15
      ) {
        setRemark(e.target.value);
        if (e && Object.keys(e).length > 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["remark_isEmpty"]: undefined,
          }));
        } else if (!e || Object.keys(e).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["remark_isEmpty"]: "Remark can not be empty",
          }));
        }
      } else {
        setRemark(e.target.value);
      }
    } else if (apiFieldName == "projectMandays") {
      setProjectMandays(e.target.value);
      //if(selectedStages.value == 2) {
      if (e && Object.keys(e).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ProjectMandays_isEmpty"]: undefined,
        }));
      } else if (!e || Object.keys(e).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ProjectMandays_isEmpty"]: "Project Mandays can not be empty",
        }));
      }
      // }
    } else if (apiFieldName == "projectValue") {
      setProjectValue(e.target.value);

      if (e && Object.keys(e).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["projectValue_isEmpty"]: undefined,
        }));
      } else if (!e || Object.keys(e).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["projectValue_isEmpty"]: "Project Value can not be empty",
        }));
      }
    }

    // else if (apiFieldName == "BudgetMandays") {
    //   setBudgetMandays(e.target.value);

    //   if (e && Object.keys(e).length > 0) {
    //     setFormErrors((preState) => ({
    //       ...preState,
    //       ["BudgetMandays_isEmpty"]: undefined,
    //     }));
    //   } else if (!e || Object.keys(e).length === 0) {
    //     setFormErrors((preState) => ({
    //       ...preState,
    //       ["BudgetMandays_isEmpty"]: "Budget Mandays can not be empty",
    //     }));
    //   }
    // }

  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      ResetFunction();
      // setSelectedEngagementValue({});
      setIsBillableStage(false);
      setSelectedEngagement(event);
      setEngagementType(event?.engmentType);
      setStagesOptions([]);
      await GetStagesDropdown(event.value);
      await GetMilestonesDropdown(event.value);
      

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
        setPage(0);
        setStart(0);
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement type can not be empty",
        }));
      }
    }

    if (apiFieldName === "stages") {
      let billableStages = [3, 4, 5, 6,13];
      setSelectedStages(event);
      if(billableStages.includes(event?.value)){
        setIsBillableStage(true)
      }else{
        setIsBillableStage(false)
      }
      
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Stages_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["Stages_isEmpty"]: "Stages can not be empty",
        }));
      }
    }

    if (apiFieldName === "effectiveDate") {
      let date = moment(event).format(moment.HTML5_FMT.DATE);
      setEffectiveDate(date);

      if (date != undefined || date != null) {
        setFormErrors((preState) => ({
          ...preState,
          ["effectiveDate_isEmpty"]: undefined,
        }));
      }
      if (date == undefined || date == null) {
        setFormErrors["effectiveDate_isEmpty"] =
          "Effective Date Can Not Be Empty";
      }
      // } else if (!event || Object.keys(event).length === 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["effectiveDate_isEmpty"]: "effectiveDate can not be empty",
      //   }));
      // }
    }

    if (apiFieldName === "plannedCompletedDate") {
      let date = moment(event).format(moment.HTML5_FMT.DATE);
      setPlannedCompletedDate(date);

      if (date != undefined || date != null) {
        setFormErrors((preState) => ({
          ...preState,
          ["plannedCompletedDate_isEmpty"]: undefined,
        }));
      }
      if (date == undefined || date == null) {
        setFormErrors["plannedCompletedDate_isEmpty"] =
          "Planned Completed Date Can Not Be Empty";
      }

    }

    //added by mahesh 
    if (apiFieldName === "milestone") {
      setSelectedMilestone(event);
      // if (event && Object.keys(event).length > 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     [""]: undefined,
      //   }));
      // } else if (!event || Object.keys(event).length === 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     [""]: "Milestone can not be empty",
      //   }));
      // }
    }
    //end

  };

  //added by mahesh 
const handleIsActiveChange = async () =>{
  setIsActive(!isActive);
}
  // end 

  const onSubmitValidation = async () => {
    await setFormErrors({});
    //formErrorObj = {};
    if (!selectedEngagement || Object.keys(selectedEngagement).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      FormErrors["engagement_isEmpty"] = "Engagement cannot be empty";
    }

    if(Object.keys(selectedEngagement).length !== 0 && selectedEngagement.engmentStatus !=3 ){

    
    if (!selectedStages || Object.keys(selectedStages).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["Stages_isEmpty"]: "Stages cannot be empty",
      }));
      FormErrors["Stages_isEmpty"] = "Stages cannot be empty";
    }

    if (!effectiveDate || Object.keys(effectiveDate).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["effectiveDate_isEmpty"]: "Effective Date cannot be empty",
      }));
      FormErrors["effectiveDate_isEmpty"] = "Effective Date cannot be empty";
    }

  }

    if (selectedStages.value == 4) {
      if (!plannedCompletedDate || Object.keys(plannedCompletedDate).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["plannedCompletedDate_isEmpty"]: "Planned Completed Date cannot be empty",
        }));
        FormErrors["plannedCompletedDate_isEmpty"] = "Planned Completed Date cannot be empty";
      }

      // if (!BudgetMandays || Object.keys(BudgetMandays).length === 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["BudgetMandays_isEmpty"]: "Budget Mandays cannot be empty",
      //   }));
      //   FormErrors["BudgetMandays_isEmpty"] = "Budget Mandays cannot be empty";
      // }
    }

    if (selectedStages.value == 2) {
      if (!ProjectMandays || Object.keys(ProjectMandays).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["ProjectMandays_isEmpty"]: "Project Mandays cannot be empty",
        }));
        FormErrors["ProjectMandays_isEmpty"] =
          "Project Mandays cannot be empty";
      }

      if (!ProjectValue || Object.keys(ProjectValue).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["projectValue_isEmpty"]: "Project Value cannot be empty",
        }));
        FormErrors["projectValue_isEmpty"] = "Project Value cannot be empty";
      }
    }

    if (
      selectedStages.value == 10 ||
      selectedStages.value == 11 ||
      selectedStages.value == 15 ||
      selectedStages.value == 12
    ) {
      if (!remark || Object.keys(remark).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["remark_isEmpty"]: "Remark cannot be empty",
        }));
        FormErrors["remark_isEmpty"] = "Remark cannot be empty";
      }
    }
  };

  const onClickFunction = async (action) => {
    let requestObject;
    if (action === "submit") {
      showLoader();

      await onSubmitValidation();

      const isEmpty = await Object.values(FormErrors).every(
        (x) => x === null || x === "" || x == undefined
      );

      if (isEmpty == true) {
        // let milestoneIds = selectedMilestone?.value
        const selectedMilestoneValues = selectedMilestone?.map(item => item?.value).join(', ');
        requestObject = {
          EmpId: Number(EmployeeId),
          EngagementId: selectedEngagement.value,
          StageId: selectedStages.value,
          CreatedBy: EmployeeId,
          EffectiveDate: effectiveDate,
          Remark: remark,
          ProjectManday: ProjectMandays,
          ProjectValue: ProjectValue,
          PlannedCompletedDate: plannedCompletedDate,
          // BudgetMandays : BudgetMandays,
          MilestoneID: isActive && selectedMilestoneValues ? selectedMilestoneValues : null,
        };

        const res = await APICall(
          InsertEngagementStagesHistoryData,
          "POST",
          requestObject
        );

        if (
          res.message === "Ok" &&
          res.data ===
          "For selected engagement the stage is already cancelled,closed,not won"
        ) {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data === "Kindly Upload the Requirement for the selected Engagement before updating the stage") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data === "All the Tickets are not closed for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "All the PreUAT requirement's status are not developed for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "All the test cases are not pass by DEV or pass by BA or pass by UAT for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "Testcases are not uploaded for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "PO Status is not recieved OR Not Applicable for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "All invoices are not recieved for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "All Tasks for the selected Engagement are not Completed") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "All the TestCase Issues are not completed for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "Some testcases are not passed on UAT for the selected Engagement") {
          notify(1, res.data);
        }
        else if (res.message === "Ok" &&
          res.data == "No resource has been allocated as Engagement Lead, nor has any capacity been allocated.") {
          notify(1, res.data);
        }

        else if (res.message === "Ok") {
          notify(0, "Data Inserted Successfully");
          await ResetFunction();
          await GetEngagementDropdown();
          // await GetEngagementStagesGridData();

          if (res.data[0].count !== undefined) {
            setCount(res.data && res.data[0].count);
          }
        }
        else {
          notify(1, "Data Insertion Failed");
          await ResetFunction();
        }
      }
    }

    hideLoader();
  };

  const GetEngagementStagesGridData = async () => {
    await showLoader();
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      EngagementId: selectedEngagement.value,
    };
    const { data } = await APICall(
      GetEngagementStageGridData,
      "POST",
      requestParams
    );

    if (data && data.length > 0) {
      await data.forEach((ele: any) => {
        ele.date = moment(ele.date).format("DD-MM-yyyy");
      });

      setEngagementStagesData(data);
      setCount(data[0].count);
      await hideLoader();
    } else {
      setPage(0);
      setStart(0);
      setCount(0);
      setEngagementStagesData(data);
      await hideLoader();
    }
  };

  // const selectOnChange = async (event: any, apiFieldName: any) => {
  //   if (apiFieldName === "engagement") {
  //     ResetFunction();
  //     setSelectedEngagementValue({});
  //     setSelectedEngagement(event);

  //     await GetStagesDropdown(event.value);

  //     if (event && Object.keys(event).length > 0) {
  //       setFormErrors((preState) => ({
  //         ...preState,
  //         ["engagement_isEmpty"]: undefined,
  //       }));
  //       setPage(0);
  //       setStart(0);
  //     } else if (!event || Object.keys(event).length === 0) {
  //       setFormErrors((preState) => ({
  //         ...preState,
  //         ["engagement_isEmpty"]: "Enagagement type can not be empty",
  //       }));
  //     }
  //   }

  //   if (apiFieldName === "stages") {
  //     setSelectedStages(event);
  //     if (event && Object.keys(event).length > 0) {
  //       setFormErrors((preState) => ({
  //         ...preState,
  //         ["Stages_isEmpty"]: undefined,
  //       }));
  //     } else if (!event || Object.keys(event).length === 0) {
  //       setFormErrors((preState) => ({
  //         ...preState,
  //         ["Stages_isEmpty"]: "Stages can not be empty",
  //       }));
  //     }
  //   }

  //   if (apiFieldName === "effectiveDate") {
  //     let date = moment(event).format(moment.HTML5_FMT.DATE);
  //     setEffectiveDate(date);

  //     if (date != undefined || date != null) {
  //       setFormErrors((preState) => ({
  //         ...preState,
  //         ["effectiveDate_isEmpty"]: undefined,
  //       }));
  //     }
  //     if (date == undefined || date == null) {
  //       setFormErrors["effectiveDate_isEmpty"] =
  //         "Effective Date Can Not Be Empty";
  //     }
  //     // } else if (!event || Object.keys(event).length === 0) {
  //     //   setFormErrors((preState) => ({
  //     //     ...preState,
  //     //     ["effectiveDate_isEmpty"]: "effectiveDate can not be empty",
  //     //   }));
  //     // }
  //   }
  // };

  // const onSubmitValidation = async () => {
  //   await setFormErrors({});
  //   //formErrorObj = {};
  //   if (!selectedEngagement || Object.keys(selectedEngagement).length === 0) {
  //     setFormErrors((preState) => ({
  //       ...preState,
  //       ["engagement_isEmpty"]: "Engagement cannot be empty",
  //     }));
  //     FormErrors["engagement_isEmpty"] = "Engagement cannot be empty";
  //   }
  //   if (!selectedStages || Object.keys(selectedStages).length === 0) {
  //     setFormErrors((preState) => ({
  //       ...preState,
  //       ["Stages_isEmpty"]: "Stages cannot be empty",
  //     }));
  //     FormErrors["Stages_isEmpty"] = "Stages cannot be empty";
  //   }

  //   if (!effectiveDate || Object.keys(effectiveDate).length === 0) {
  //     setFormErrors((preState) => ({
  //       ...preState,
  //       ["effectiveDate_isEmpty"]: "Effective Date cannot be empty",
  //     }));
  //     FormErrors["effectiveDate_isEmpty"] = "Effective Date cannot be empty";
  //   }
  // };

  // const onClickFunction=async(action)=>{
  //   let requestObject;
  //   if(action === "submit"){
  //     showLoader();
  //    await  onSubmitValidation();
  //    const isEmpty = await Object.values(FormErrors).every(
  //     (x) => x === null || x === "" || x == undefined
  //   );

  //      requestObject ={

  //       EngagementId : selectedEngagement.value,
  //       StageId : selectedStages.value,
  //       CreatedBy : EmployeeId,
  //       Remark : remark,

  //     }
  //   } if (requestObject !== null) {
  //     const res = await APICall(
  //       InsertEngagementStagesHistoryData,
  //       "POST",
  //       requestObject
  //     );

  //     if ( res.message == "Ok") {
  //       notify(0, "Data Inserted Successfully");
  //       await GetEngagementStagesGridData();
  //     } else {
  //       notify(1, "Data Insertion Failed");
  //     }
  //   }
  //   hideLoader();

  // }
  // const onClickFunction = async (action) => {
  //   let requestObject;
  //   if (action === "submit") {
  //     showLoader();
  //     await onSubmitValidation();

  //     const isEmpty = await Object.values(FormErrors).every(
  //       (x) => x === null || x === "" || x == undefined
  //     );

  //     if (isEmpty == true) {
  //       requestObject = {
  //         EngagementId: selectedEngagement.value,
  //         StageId: selectedStages.value,
  //         CreatedBy: EmployeeId,
  //         EffectiveDate: effectiveDate,
  //         Remark: remark,
  //       };

  //       const res = await APICall(
  //         InsertEngagementStagesHistoryData,
  //         "POST",
  //         requestObject
  //       );

  //       if (
  //         res.message === "Ok" &&
  //         res.data ===
  //           "For selected engagement the stage is already cancelled,closed,not won"
  //       ) {
  //         notify(1, res.data);
  //       } else if (res.message === "Ok") {
  //         notify(0, "Data Inserted Successfully");
  //         await ResetFunction();
  //         await GetEngagementStagesGridData();
  //         setCount(res.data[0].count);
  //       } else {
  //         notify(1, "Data Insertion Failed");
  //         await ResetFunction();
  //       }
  //     }
  //   }

  //   hideLoader();
  // };

  // const GetEngagementStagesGridData = async () => {
  //   await showLoader();
  //   let requestParams = {
  //     start: start,
  //     pageSize: pageSize,
  //     sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
  //     sortOrder: sortDirection === "" ? "Desc" : sortDirection,
  //     searchText: searchText,
  //     EngagementId:
  //       selectedEngagementValue && selectedEngagementValue.value
  //         ? selectedEngagementValue.value
  //         : selectedEngagement.value,
  //   };
  //   const { data } = await APICall(
  //     GetEngagementStageGridData,
  //     "POST",
  //     requestParams
  //   );

  //   if (data && data.length > 0) {
  //     await data.forEach((ele: any) => {
  //       ele.date = moment(ele.date).format("DD-MM-yyyy");
  //     });

  //     setEngagementStagesData(data);
  //     setCount(data[0].count);
  //     await hideLoader();
  //   } else {
  //     setPage(0);
  //     setStart(0);
  //     setCount(0);
  //     setEngagementStagesData(data);
  //     await hideLoader();
  //   }
  // };

  const ExportToExcel = async () => {
    showLoader();

    let requestParams = {
      start: start,
      pageSize: count,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      EngagementId: selectedEngagement && selectedEngagement.value,
      // pageSize: count,
      // start: start,
      // sortColumn: sortColumn,
      // sortOrder: sortDirection,
      // searchText: searchText,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: getExportToExcelEngagementStages,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(response.data, "EngagementStages Report.xlsx");
      })
      .catch((error) => {
        console.error(error.response.data);
      });
    hideLoader();
  };

  return (
    <>
      <Heading title={"Engagement Stages"} />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>{" "}
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={selectedEngagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{FormErrors["engagement_isEmpty"]}</p>
            </div>
          </div>

          {selectedEngagement.value &&
            selectedEngagement?.engmentStatus != 3 && (
              <>
                {" "}
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Stages <sup>*</sup>{" "}
                    </label>
                    <SelectForm
                      options={StagesOptions}
                      placeholder="Select"
                      isDisabled={false}
                      value={selectedStages}
                      onChange={(event) => selectOnChange(event, "stages")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>
                      {FormErrors["Stages_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6 ">
                  <div className="form-group">
                    <label>
                      Effective Date <sup>*</sup>{" "}
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Effective Date"
                        value={effectiveDate}
                        onChange={(e) => selectOnChange(e, "effectiveDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                        InputProps={{ placeholder: "dd/MM/yyyy" }}
                        minDate={new Date("1900-01-01")}
                        maxDate={new Date()}
                        disableFuture
                        //showToolbar={true}
                      />
                    </LocalizationProvider>
                    <p style={{ color: "red" }}>
                      {FormErrors["effectiveDate_isEmpty"]}
                    </p>
                  </div>
                </div>
              </>
            )}
        </div>

        <div className="row">
          {selectedEngagement.value &&
            selectedEngagement?.engmentStatus != 3 && (
              <>
                {selectedStages &&
                (selectedStages.value == 10 ||
                  selectedStages.value == 15 ||
                  selectedStages.value == 11 ||
                  selectedStages.value == 12) ? (
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>
                        Remark <sup>*</sup>
                      </label>

                      <InputForm
                        placeholder={""}
                        isDisabled={false}
                        textArea={true}
                        value={remark}
                        rows={3}
                        onChange={(e) => handleTextChange(e, "remark")}
                      />
                      <p style={{ color: "red" }}>
                        {FormErrors["remark_isEmpty"]}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>Remark</label>

                      <InputForm
                        placeholder={""}
                        isDisabled={false}
                        textArea={true}
                        value={remark}
                        rows={3}
                        onChange={(e) => handleTextChange(e, "remark")}
                      />
                    </div>
                  </div>
                )}
                {/* <div className="col-lg-4 col-md-4 col-sm-6 justify-align-center ">
                <div className="form-group">
                  <label>Remark</label>

                  <InputForm
                    placeholder={""}
                    isDisabled={false}
                    textArea={true}
                    value={remark}
                    onChange={(e) => handleTextChange(e, "remark")}
                  />
                </div>
              </div> */}

                {selectedStages && selectedStages.value == 4 ? (
                  <>
                    {/* <div className="col-lg-4 col-md-4 col-sm-6 justify-align-center">
                    <div className="form-group">
                      <label>
                        Budget Mandays <sup>*</sup>
                      </label>
                      <InputForm
                        placeholder={"Budget Mandays"}
                        isDisabled={false}
                        textArea={false}
                        value={BudgetMandays}
                        onChange={(e) =>
                          handleTextChange(e, "BudgetMandays")
                        }
                        className="numRight"
                        type="number"
                        onKeyPress={(event) => {
                          if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <p style={{ color: "red" }}>
                        {FormErrors["BudgetMandays_isEmpty"]}
                      </p>
                    </div>
                  </div> */}

                    <div className="col-lg-4 col-md-4 col-sm-6 ">
                      <div className="form-group">
                        <label>
                          Planned Completed date <sup>*</sup>{" "}
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="Planned Completed Date"
                            value={plannedCompletedDate}
                            onChange={(event) =>
                              selectOnChange(event, "plannedCompletedDate")
                            }
                            inputFormat="dd/MM/yyyy"
                            //maxDate= {new Date()}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                          />
                          <p style={{ color: "red" }}>
                            {FormErrors["plannedCompletedDate_isEmpty"]}
                          </p>
                        </LocalizationProvider>
                      </div>
                    </div>
                  </>
                ) : null}
                {/* */}

                {selectedStages && selectedStages.value == 2 ? (
                  <>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          Project Value <sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={"Project Value"}
                          isDisabled={false}
                          textArea={false}
                          value={ProjectValue}
                          onChange={(e) => handleTextChange(e, "projectValue")}
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <p style={{ color: "red" }}>
                          {FormErrors["projectValue_isEmpty"]}
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          Project Mandays <sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={"Project Mandays"}
                          isDisabled={false}
                          textArea={false}
                          value={ProjectMandays}
                          onChange={(e) =>
                            handleTextChange(e, "projectMandays")
                          }
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <p style={{ color: "red" }}>
                          {FormErrors["ProjectMandays_isEmpty"]}
                        </p>
                      </div>
                    </div>
                  </>
                ) : null}

                {/* added by mahesh  */}
                {isBillableStage && engagementType == 3 && (
                  <div className="col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group">
                      <label>Is Billable</label>
                      <div>
                        <input
                          type="checkbox"
                          id="chkbox1"
                          checked={isActive}
                          onChange={handleIsActiveChange}
                          // disabled={EditId ? false : true}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {isActive && (
                  <div className="col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group">
                      <label>Milestones</label>
                      <SelectForm
                        options={milestoneOptions}
                        placeholder="Select"
                        isDisabled={false}
                        value={selectedMilestone}
                        onChange={(event) => selectOnChange(event, "milestone")}
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      />
                    </div>
                  </div>
                )}
              </>
            )}

          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <button
                onClick={() => onClickFunction("submit")}
                className="btn btn-submit"
                disabled={selectedEngagement?.engmentStatus == 3 ? true : false}
              >
                Submit
              </button>
            </div>
          </div>

          <div className="col-lg-12 mt-3">
            {
              <DynamicGrid
                options={options}
                data={EngagementStagesData || []}
                columns={gridColumns}
              />
            }
          </div>

          <div className="col-lg-12 mt-3">
            <button onClick={() => navigate(-1)} className="btn btn-reset">
              <i className="fa fa-chevron-left"></i>
            </button>
          </div>
        </div>
      </div>

      {/* {EngagementStagesData && EngagementStagesData.length >= 0 && (
      <DynamicGrid
        options={options}
        data={EngagementStagesData}
        columns={gridColumns}
      />
      )
      } */}
    </>
  );
}

export default TraceabilityEngagementStages;
